import React from 'react';
import b_ from 'b_';

import {LinkPage} from 'client/common/utils/header-link';
import {createUrl} from 'client/common/utils/history';
import I18N from 'assets/i18n/brandlift-project';
import {sendGoal} from 'client/common/utils/metrika';
import {PollLandingGoal} from 'client/common/types';

import './header.css';

import LogoIcon from './logo.svg';

const b = b_.with('header');
const i18n = I18N.common.header2;
const meaningfulElemName = 'menu-link';

export const headerMeaningfulSelector = `.${b(meaningfulElemName)}`;

export default function Header() {
    return (
        <div className={b()} onClick={() => sendGoal(PollLandingGoal.ActionLogoClick)}>
            <a className={b(meaningfulElemName)} href={createUrl({link: LinkPage.Root})}>
                <img
                    className={b('title-logo')}
                    alt={i18n.logo.yandex}
                    src={`https://yastatic.net/q/logoaas/v2/${i18n.logo.yandex}%20.svg?size=32&color=1B202B`}
                />
                <img className={b('logo')} src={LogoIcon} />
                <img
                    className={b('service-logo')}
                    alt={i18n.logo.surveys}
                    src={`https://yastatic.net/q/logoaas/v2/%20${i18n.logo.surveys}.svg?size=32&color=1B202B`}
                />
            </a>
        </div>
    );
}
